import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [totpCode, setTotpCode] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [needs2FA, setNeeds2FA] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success] = useState(location.state?.setup2FAComplete ? '2FA configurado. Inicia sesión con tu código.' : '');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const result = await login(email, password, needs2FA ? totpCode : null, rememberMe);
      if (result.needs2FA) {
        setNeeds2FA(true);
        setLoading(false);
        return;
      }
      if (result.needs2FASetup) {
        // 2FA required but not configured — save temp token and redirect to setup
        localStorage.setItem('token', result.tempToken);
        navigate('/setup-2fa', { state: { forced: true } });
        return;
      }
      if (result.user?.mustChangePassword) {
        navigate('/change-password');
      } else {
        navigate('/');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#0f1117' }}>
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-2">
            <div className="w-9 h-9 rounded-lg flex items-center justify-center font-bold text-lg" style={{ backgroundColor: '#FFB800', color: '#0f1117' }}>E</div>
            <h1 className="text-2xl font-bold text-white tracking-wide">ENCOM TOOLS</h1>
          </div>
          <p className="text-sm" style={{ color: 'rgba(255,255,255,0.4)' }}>Accede a tus herramientas</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-6 shadow-2xl">
          {success && (
            <div className="text-sm px-3 py-2 rounded-lg mb-4" style={{ backgroundColor: '#e8f5e9', color: '#2e7d32' }}>{success}</div>
          )}
          {error && (
            <div className="text-sm px-3 py-2 rounded-lg mb-4" style={{ backgroundColor: '#fef2f2', color: '#dc2626' }}>{error}</div>
          )}

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="tu@encom.es"
              className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:border-transparent"
              style={{ '--tw-ring-color': '#FFB800' }}
              required
              autoFocus
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:border-transparent"
              style={{ '--tw-ring-color': '#FFB800' }}
              required
            />
          </div>

          {needs2FA && (
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">Código 2FA</label>
              <input
                type="text"
                value={totpCode}
                onChange={e => setTotpCode(e.target.value)}
                placeholder="123456"
                maxLength={6}
                className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm text-center tracking-widest focus:outline-none focus:ring-2"
                autoFocus
              />
            </div>
          )}

          <div className="flex items-center mb-5">
            <input
              type="checkbox"
              id="remember"
              checked={rememberMe}
              onChange={e => setRememberMe(e.target.checked)}
              className="rounded border-gray-300"
            />
            <label htmlFor="remember" className="ml-2 text-sm text-gray-500">Mantener sesión iniciada</label>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-accent w-full py-2.5 rounded-lg text-sm transition-colors"
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
